import { Badge } from 'antd';
import { NotificationDropdown } from 'features/notification/components/NotificationPanel/NotificationDropdown';
import { NotificationOverlay } from 'features/notification/components/NotificationPanel/NotificationOverlay';
import { formatUnreadBadge } from 'features/notification/helpers';
import { useGetNotificationUnreadCountQuery } from 'features/notification/query';
import { memo, useMemo } from 'react';
import { BellLinearIcon } from 'shared/components/AppIcon';
import { useGetAppBreakPoints } from 'shared/hooks/useGetAppBreakPoints';

export const NotificationPanel = memo(() => {
  const { isPortraitTablet } = useGetAppBreakPoints();

  const { data: unreadCount } = useGetNotificationUnreadCountQuery(undefined, {
    refetchOnMountOrArgChange: true,
    refetchOnFocus: true,
  });

  const trigger = useMemo(
    () => (
      <Badge
        count={
          <small className="rounded-full min-w-4.5 text-center bg-error p-1 text-[1rem] text-white">
            {formatUnreadBadge(unreadCount?.total)}
          </small>
        }
        offset={[-6, -3]}
        size="small"
      >
        <div className="flex h-10 w-10 shrink-0 cursor-pointer items-center justify-center rounded-full bg-neutral-50 hover:bg-neutral-200 md:h-9 md:w-9">
          <BellLinearIcon className="h-6 w-6 cursor-pointer text-black" />
        </div>
      </Badge>
    ),
    [unreadCount?.total]
  );

  return isPortraitTablet ? (
    <NotificationOverlay>{trigger}</NotificationOverlay>
  ) : (
    <NotificationDropdown>{trigger}</NotificationDropdown>
  );
});
